import React from "react";
import cx from "classnames";
import { Link } from "src/components/link";
import { Image } from "src/components/image";
import { getInternalLinkPath } from "src/utils/getInternalLinkPath";

import styles from "./mission-statement.module.css";

interface MissionStatementProps {
  module: {
    copy?: string;
    graphic?: any;
    cta?: {
      link: any;
      title: string;
    };
  };
}

export const MissionStatement = ({ module }: MissionStatementProps) => {
  const { copy, graphic, cta } = module;
  return (
    <div className={cx(styles.missionStatement)}>
      <Image
        className={styles.graphic}
        src={graphic.asset.url}
        width={112}
        alt="Emme: Woman on a mission"
      />
      <p className={cx("headline c-terracotta", styles.copy)}>{copy}</p>
      {cta && (
        <Link
          className={cx("body", styles.link)}
          type="internalLink"
          to={getInternalLinkPath(cta.internalLink.link)}
        >
          {cta.linkCopy}
        </Link>
      )}
    </div>
  );
};
